import React from 'react';
import logo from 'assets/images/xstak-loader.gif';

const Loader = () => {
  return (
    <div className='fixed top-0 right-0 flex h-screen w-screen justify-center items-center bg-white z-30 site-loader'>
      <img src='/xpaylogo.svg' alt='Workflow' className='h-[50px] w-[50px] animate-spin' />
    </div>
  );
};

export default Loader;
